import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useResultStyles = makeStyles((theme: Theme) => createStyles({
    item: {
        margin: '16px',
        maxWidth: '730px',
        textAlign: 'center'
    },
    title: {
        margin: '100px 24px 24px',
        maxWidth: '730px',
        textAlign: 'center'
    },
    nameFile: {
        margin: '16px 16px 50px',
        maxWidth: '730px',
        textAlign: 'center'
    },
    icon: {
        fontSize: '100px',
        marginTop: '24px'
    },
    iconWarning: {
        fontSize: '100px',
        color: theme.palette.warning.main
    },
    button: {
        width: '430px',
        margin: '10px'
    },
}));

export const useInputStyles = makeStyles((theme: Theme) => createStyles({
    item: {
        margin: '24px',
        maxWidth: '930px',
        textAlign: 'center'
    },
    title: {
        margin: '24px auto 110px',
        maxWidth: '730px',
        textAlign: 'center'
    },
    fields: {
        width: '430px',
        margin: '20px',
    },
    textLink: {
        marginTop: '-12px',
        marginBottom: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start',
        textDecoration: 'none',
        color: theme.palette.text.primary
    },
    itemDetail: {
        marginLeft: '4px',
    },
    infoText: {
        paddingTop: '16px',
        paddingBottom: '16px'
    },
    alignItemTextCenter: {
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    textStart: {
        display: 'grid',
        alignItems: 'center',
        justifyContent: 'flex-start',
    }
}));